<div class="cerrar-posicion-dialog"
     [ngClass]="{ 'dark-theme': theme === 'dark-theme', 'light-theme': theme !== 'dark-theme' }">

  <!-- Header fijo -->
  <div class="guardar-header d-flex align-items-center justify-content-between sticky-top">
    <h2 class="guardar-title m-0">
      <mat-icon class="me-2">logout</mat-icon>
      Cerrar Posición
    </h2>
    <button mat-icon-button class="close-button" mat-dialog-close aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Contenido con scroll propio -->
  <div class="guardar-content scroll-content">

    <!-- Fuente Data -->
    <div class="section-header">
      <mat-icon class="small-icon">source</mat-icon>
      <span>Fuente Data</span>
      <span class="fuente-badge ms-auto">API</span>
    </div>

    <!-- Tabla de mercado -->
    <div class="mb-3">
      <div class="market-quote" *ngFor="let element of dataSource">
        <div class="market-quote-grid">
          <span class="market-quote-symbol">{{ element.symbol }}</span>
          <span class="market-quote-side">Bid <b>{{ element.bidPrice | number: '1.2-2' }}</b></span>
          <span class="market-quote-last">{{ element.lastSalePrice }}</span>
          <span class="market-quote-side">Ask <b>{{ element.askPrice | number: '1.2-2' }}</b></span>
        </div>
      </div>
    </div>

    <!-- Compañía -->
    <div class="section-header">
      <mat-icon class="small-icon">business</mat-icon>
      <span>Compañía</span>
    </div>

    <div class="fields-grid">
      <label class="field-label">Nueva Compañia</label>
      <select class="dense-input listas" aria-label="Nueva Compañia"
          [(ngModel)]="selectedDato" (change)="seleccionarDato()">
        <option *ngFor="let dato of ListaPosicion" [ngValue]="dato">{{ dato.ticker }}</option>
      </select>
    </div>

    <!-- Orden -->
    <div class="section-header mt-3">
      <mat-icon class="small-icon">receipt_long</mat-icon>
      <span>Orden</span>
    </div>

    <div class="fields-grid">
      <label class="field-label">Tipo Orden</label>
      <select class="dense-input listas" name="orderType" aria-label="Tipo Orden"
          [(ngModel)]="ordersData.orders[0].orderType">
        <option value="{{type}}" *ngFor="let type of orderType">{{type}}</option>
      </select>
    </div>

    <!-- Parámetros -->
    <div class="section-header mt-3">
      <mat-icon class="small-icon">analytics</mat-icon>
      <span>Parámetros</span>
    </div>

    <div class="fields-grid">
      <label class="field-label">Cotización</label>
      <input type="number" class="dense-input" [(ngModel)]="isActual">

      <label class="field-label">Precio Entrada</label>
      <input type="number" class="dense-input" [(ngModel)]="posicion.avgPrice">

      <label class="field-label">Coste</label>
      <input type="number" class="dense-input" [(ngModel)]="posicion.coste">

      <label class="field-label">Retorno</label>
      <input type="number" class="dense-input" [(ngModel)]="retorno">

      <label class="field-label">N° Acciones</label>
      <input type="number" class="dense-input" [(ngModel)]="posicion.position">
    </div>

  </div>

  <!-- Acciones fijas abajo -->
  <div class="guardar-actions d-flex justify-content-end gap-2 actions-sticky">
    <button mat-stroked-button mat-dialog-close>
      <mat-icon class="me-1">close</mat-icon>
      Cancelar
    </button>
    <button mat-flat-button class="btn-accept-gradient" (click)="enviarPosicion()">
      <mat-icon class="me-1">check</mat-icon>
      Aceptar
    </button>
  </div>

</div>
